"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _currentLanguageHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/current-language-helper"));

var _scriptHelper = require("@eig-builder/core-utils/helpers/script-helper");

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var _postMessageHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/post-message-helper"));

var _compositionsLoaderWithTimeout = require("@eig-builder/compositions-loader-with-timeout");

var _context = _interopRequireDefault(require("./../context"));

var _store = _interopRequireWildcard(require("./../store"));

var _localizeFormatter = _interopRequireDefault(require("./../helpers/localize-formatter"));

/**
 * Localization wrapper - it will display its children when its finished loading
 *
 * @class Localization
 * @extends {Component}
 * @param retrieving - can be used for loading indicator
 * @param translationKeys - translation keys received from server
 * @param error - error during translation fetch
 * @param localize - "the localize" function
 * @param _localizeDebug - enable debug, inline editing
 */
var Localization =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Localization, _Component);

  function Localization(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Localization);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Localization).call(this, props));

    _this.subscribeToTanslationChange = function () {
      // Set value in translationKeys for posible redraw of a screen
      _this.postMessageHandler = new _postMessageHelper["default"]();

      _this.postMessageHandler.bind('translation_message', function (data) {
        _this.props.translationKeys[data.key] = data.text;
      });
    };

    _this.unSubscribeToTanslationChange = function () {
      if (_this.postMessageHandler) {
        _this.postMessageHandler.clear();

        _this.postMessageHandler = null;
      }
    };

    _this.localize = function (key, values) {
      values = values || [];
      var messages = _this.props.translationKeys;
      var message = (0, _get["default"])(messages, key, null);
      return _this.props.localize(message, key, values);
    };

    _this.localize = _this.localize.bind((0, _assertThisInitialized2["default"])(_this));
    _this._localizeDebug = _this.props._localizeDebug;
    return _this;
  }

  (0, _createClass2["default"])(Localization, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props._localizeDebug) {
        this.loadInlineEditor();
      }
    }
    /**
     * Load the inline editor from the translation backend
     *
     *
     * @memberOf Localization
     */

  }, {
    key: "loadInlineEditor",
    value: function loadInlineEditor() {
      var _this2 = this;

      var url = (0, _urlHelper.getUrl)(_urlHelper.siteNames.TRANSLATION, "/v1.0/inlineeditor/script.js");
      (0, _scriptHelper.IncludeJavaScript)(url, 'inline-localizations-editor', function () {
        var language = (0, _currentLanguageHelper["default"])();
        window.localizationPopup.setLanguageCode(language);
        window.localizationPopup.setGroup('Javascript');
        window.localizationPopup.setProduct('controlpanel');

        _this2.subscribeToTanslationChange();
      });
    }
    /**
     * subscribe To Tanslation Change to the post messages, that are send from the iframe inside the inline editor modal
     * the new translation will be showed after it was received
     *
     *
     * @memberOf TextComponent
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // unsubscript post message handler
      this.unSubscribeToTanslationChange();
    }
    /**
     * The real localize function, this can be called in a child component using this.context.localize
     *
     * @param {any} key - tranlsation key
     * @param {any} values - used for string format
     * @returns {string} translated and formatted message
     *
     * @memberOf Localization
     */

  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement(Provider, {
        _localizeDebug: this._localizeDebug,
        localize: this.localize,
        children: this.props.children,
        retrieving: this.props.retrieving
      });
    }
  }]);
  return Localization;
}(_react.Component);

var Provider = function Provider(props) {
  var _useReducer = (0, _react.useReducer)(_store["default"], _store.initialState),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _localizeProviderValue = {
    localize: props.localize,
    _localizeDebug: props._localizeDebug,
    state: state,
    dispatch: dispatch
  };

  if (props.retrieving !== false) {
    return _react["default"].createElement(_context["default"].Provider, {
      value: _localizeProviderValue
    }, _react["default"].createElement(_compositionsLoaderWithTimeout.LoaderWithBackdrop, {
      centeredX: true,
      centeredY: true
    }));
  }

  return _react["default"].createElement(_context["default"].Provider, {
    value: _localizeProviderValue
  }, props.children);
};

Provider.propTypes = {
  children: _propTypes["default"].element,
  retrieving: _propTypes["default"].bool,
  localize: _propTypes["default"].func,
  _localizeDebug: _propTypes["default"].bool
};
Localization.propTypes = {
  children: _propTypes["default"].element,
  retrieving: _propTypes["default"].bool,
  translationKeys: _propTypes["default"].object,
  localize: _propTypes["default"].func,
  _localizeDebug: _propTypes["default"].bool
};
Localization.defaultProps = {
  localize: _localizeFormatter["default"],
  _localizeDebug: false
};
var _default = Localization;
exports["default"] = _default;